/* Nivorra: product gallery, product form, and optional refill line item. */
(function () {
  function initialize(root) {
    if (!root || root.dataset.nvReady === 'yes') return;
    root.dataset.nvReady = 'yes';

    /* Product image gallery */
    const gallery = root.querySelector('[data-gallery]');
    const mainImage = root.querySelector('.nv-gallery__main-image');
    const thumbs = Array.from(root.querySelectorAll('.nv-gallery__thumb'));
    const count = root.querySelector('.nv-gallery__count span');
    let imageIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;

    function showImage(index) {
      if (!mainImage || !thumbs.length) return;

      imageIndex = (index + thumbs.length) % thumbs.length;
      const selectedThumb = thumbs[imageIndex];
      const imageUrl = selectedThumb.dataset.src;

      /*
        Clear the original responsive image sources first.
        Otherwise the browser may keep displaying the old image
        from the original srcset.
      */
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
      mainImage.alt = selectedThumb.dataset.alt || '';

      thumbs.forEach(function (button, buttonIndex) {
        const isSelected = buttonIndex === imageIndex;
        button.classList.toggle('active', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });

      if (count) {
        count.textContent = String(imageIndex + 1);
      }
    }

    thumbs.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showImage(index);
      });
    });

    const previousButton = root.querySelector('.nv-gallery__arrow.prev');
    const nextButton = root.querySelector('.nv-gallery__arrow.next');

    previousButton?.addEventListener('click', function () {
      showImage(imageIndex - 1);
    });

    nextButton?.addEventListener('click', function () {
      showImage(imageIndex + 1);
    });

    /* Swipe left or right on the main product photo on touchscreens */
    if (gallery && mainImage) {
      gallery.addEventListener('touchstart', function (event) {
        const touch = event.changedTouches[0];
        touchStartX = touch.screenX;
        touchStartY = touch.screenY;
      }, { passive: true });

      gallery.addEventListener('touchend', function (event) {
        const touch = event.changedTouches[0];
        const differenceX = touchStartX - touch.screenX;
        const differenceY = touchStartY - touch.screenY;

        /* Ignore vertical page scrolling and small finger movements */
        if (
          Math.abs(differenceX) > 45 &&
          Math.abs(differenceX) > Math.abs(differenceY) * 1.2
        ) {
          showImage(imageIndex + (differenceX > 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    /* Product form */
    const form = root.querySelector('.nv-product-form');
    if (!form) return;

    const qty = form.querySelector('.nv-qty input');
    const variantIdInput = form.querySelector('.nv-variant-id');
    const variantSelector = form.querySelector('.nv-variant-select');
    const atc = form.querySelector('.nv-atc');
    const message = form.querySelector('.nv-cart-message');
    const refill = root.querySelector('.nv-refill-check');
    const total = form.querySelector('.nv-total strong');
    const mainPrice = root.querySelector('.nv-price');
    const comparePrice = root.querySelector('.nv-compare');
    const save = root.querySelector('.nv-save');
    const offerPrice = root.querySelector('.nv-main-offer-price');
    const variantsNode = root.querySelector('.nv-product-variants');

    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    let selected = variants.find(function (variant) {
      return String(variant.id) === String(variantIdInput?.value);
    }) || variants[0];

    function money(cents) {
      const amount = Number(cents) / 100;
      const currency = document.documentElement.dataset.currency || 'USD';

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          { style: 'currency', currency: currency }
        ).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function getQty() {
      return Math.max(1, Math.trunc(Number(qty?.value) || 1));
    }

    function updateTotal() {
      if (!selected) return;

      const refillPrice =
        refill?.checked && root.dataset.refillVariant
          ? Number(root.dataset.refillPrice)
          : 0;

      const sum = Number(selected.price) * getQty() + refillPrice;

      if (total) {
        total.textContent = money(sum);
      }
    }

    function selectVariant(id) {
      const variant = variants.find(function (item) {
        return String(item.id) === String(id);
      });

      if (!variant) return;

      selected = variant;

      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      if (mainPrice) {
        mainPrice.textContent = money(variant.price);
      }

      if (offerPrice) {
        offerPrice.textContent = money(variant.price);
      }

      if (comparePrice) {
        const hasComparePrice = variant.compare_at_price > variant.price;
        comparePrice.textContent = hasComparePrice
          ? money(variant.compare_at_price)
          : '';
        comparePrice.hidden = !hasComparePrice;
      }

      if (save) {
        const hasSavings = variant.compare_at_price > variant.price;
        save.hidden = !hasSavings;
        save.textContent = hasSavings
          ? 'SAVE ' + Math.round(
              100 * (variant.compare_at_price - variant.price) /
              variant.compare_at_price
            ) + '%'
          : '';
      }

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available
          ? (atc.dataset.addLabel || 'Add to Cart')
          : 'Sold Out';
      }

      updateTotal();
    }

    variantSelector?.addEventListener('change', function () {
      selectVariant(variantSelector.value);
    });

    form.querySelector('.nv-qty .minus')?.addEventListener('click', function () {
      if (!qty) return;
      qty.value = Math.max(1, getQty() - 1);
      updateTotal();
    });

    form.querySelector('.nv-qty .plus')?.addEventListener('click', function () {
      if (!qty) return;
      qty.value = getQty() + 1;
      updateTotal();
    });

    qty?.addEventListener('change', function () {
      qty.value = getQty();
      updateTotal();
    });

    refill?.addEventListener('change', updateTotal);
    updateTotal();

    /*
      Without the optional refill checked, Shopify submits the product form
      normally. If checked, add both products to the cart together.
    */
    form.addEventListener('submit', async function (event) {
      if (!refill?.checked || !root.dataset.refillVariant || !selected) return;

      event.preventDefault();

      if (atc) {
        atc.disabled = true;
        atc.textContent = 'Adding…';
      }

      if (message) {
        message.hidden = true;
      }

      const items = [
        { id: Number(selected.id), quantity: getQty() },
        { id: Number(root.dataset.refillVariant), quantity: 1 }
      ];

      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const error = await response.json().catch(function () {
            return {};
          });
          throw new Error(error.description || 'Unable to add the bundle.');
        }

        window.location.assign(base + 'cart');
      } catch (error) {
        if (atc) {
          atc.disabled = false;
          atc.textContent = atc.dataset.addLabel || 'Add to Cart';
        }

        if (message) {
          message.textContent = error.message || 'Could not add items to cart.';
          message.hidden = false;
        }
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-nv-product]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();